
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/family-friendly-vacations",
      function () {
        return require("private-next-pages/blog/family-friendly-vacations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/family-friendly-vacations"])
      });
    }
  